<template>
  <div style="max-height: 1080px">
    <v-sheet v-if="(!isRHProtegido && !hasInvoicingQueryParameters()) || !maximize" height="80" width="100%" color="primary" />

    <v-container fluid class="fill-height d-flex align-start" style="padding: 10px 35px 0 !important">
      <v-row>
        <v-col
          cols="12"
          :class="{
            'd-flex pb-1': true,
            'justify-space-between': !isRHProtegido,
            'justify-start': isRHProtegido,
          }"
        >
          <v-btn v-if="!isRHProtegido && maximize" outlined style="height: 50px; width: 130px; border-radius: 10px" color="primary" @click="openNewTab"> Maximizar </v-btn>
        </v-col>

        <v-tabs background-color="transparent" color="primary" v-model="invoicingTabItems" style="padding: 0 12px 10px">
          <v-tab key="invoicing" href="#invoicing" v-if="validateTabPermission('invoicing')"> Faturamento </v-tab>

          <v-tab key="reports" href="#reports" v-if="!isHelpdesk && validateTabPermission('reports')"> Meus Relatórios </v-tab>
        </v-tabs>

        <v-tabs-items class="transparent" v-model="invoicingTabItems" style="width: 100%">
          <v-tab-item key="invoicing" value="invoicing" class="transparent" v-if="validateTabPermission('invoicing')">
            <v-container fluid>
              <v-row>
                <v-col cols="12" v-if="!isHelpdesk">
                  <InvoicingFilter />
                </v-col>

                <v-col cols="12" v-if="!isHelpdesk">
                  <v-row>
                    <v-col
                      cols="12"
                      :class="{
                        'd-flex justify-end': $vuetify.breakpoint.lgAndUp,
                        'd-flex justify-center py-1': $vuetify.breakpoint.mdAndDown,
                      }"
                    >
                      <InvoicingActions />
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <InvoicingHrProtectedTable v-if="isRHProtegido && !isHelpdesk && appOrigin !== 'BACKOFFICE'" @selectedFiles="getSelectedFileIds" />
                  <InvoicingXippPlatformTable v-if="!isRHProtegido" />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item key="reports" value="reports" v-if="!isHelpdesk && validateTabPermission('reports')">
            <ReportView :tab="invoicingTabItems" />
          </v-tab-item>
        </v-tabs-items>
      </v-row>

      <FullScreenLoader v-if="loadPage" />

      <SnackbarCustomize ref="InvoicingSnackbar" />

      <ExportReportModal :show="showRequestModal" />

      <ExportReportConfirmModal :show="showConfirmModal" />
    </v-container>
  </div>
</template>

<script>
import ExportReportConfirmModal from "@/components/Invoicing/components/ExportReportConfirmModal.vue";
import GenericFunctionsMixin from "@/shared/mixins/genericFunctions/genericFunctionsMixin";
import ExportReportModal from "@/components/Invoicing/components/ExportReportModal.vue";
import FullScreenLoader from "@/components/FullScreenLoader/FullScreenLoader.vue";
import SnackbarCustomize from "@/components/CustomAlerts/SnackbarCustomize.vue";
import InvoicingActions from "@/components/Invoicing/components/invoicing/InvoicingActions.vue";
import InvoicingFilter from "@/components/Invoicing/components/invoicing/InvoicingFilter.vue";
import InvoicingHrProtectedTable from "@/components/Invoicing/components/invoicing/InvoicingHrProtectedTable.vue";
import ReportView from "@/views/invoicing/invoicingReport.vue";

import InsuranceCarriersMixin from "@/shared/mixins/sdi/insuranceCarriersMixin";
import FinancialGroupsMixin from "@/shared/mixins/sdi/financialGroupsMixin";
import InvoicingRules from "@/components/Invoicing/rules/invoicingRules.js";
import InvoicingMixin from "@/shared/mixins/invoicing/invoicingMixin";
import ContractsMixin from "@/shared/mixins/sdi/contractsMixin";

import { BTN_FOOTER } from "@/components/Invoicing/constants/viewStyles";
import { mapActions, mapGetters, mapMutations } from "vuex";
import moment from "moment";
import InvoicingXippPlatformTable from "@/components/Invoicing/components/invoicing/InvoicingXippPlatformTable.vue";

export default {
  name: "InvoicingView",

  components: {
    ExportReportConfirmModal,
    ExportReportModal,
    SnackbarCustomize,
    FullScreenLoader,
    InvoicingActions,
    InvoicingFilter,
    InvoicingHrProtectedTable,
    InvoicingXippPlatformTable,
    ReportView,
  },

  data: () => ({
    maximize: false,
    financialGroups: [],
    moment,
    scrollHeight: null,
    invoicingScrollHeightObserver: null,
    selectedFileIds: [],
  }),

  mixins: [InsuranceCarriersMixin, GenericFunctionsMixin, FinancialGroupsMixin, ContractsMixin, InvoicingRules, InvoicingMixin],

  watch: {
    invoicingScrollHeightObserver: {
      handler(viewScrollHeight) {
        console.log(`%c🟩 scrollHeight: ${viewScrollHeight}px`, "color: white; background: green; padding: 4px; border-radius: 4px; font-weight: bold;");
        window.parent.postMessage({ iframeHeight: viewScrollHeight }, "*");
      },
    },
  },

  methods: {
    ...mapActions({
      setInvoicingFilter: "invoicing/setInvoicingFilter",
      fetchInvoices: "invoicing/fetchInvoices",
    }),

    ...mapMutations({
      resetInsuranceCarriers: "insurance-carrier/resetModule",
      resetFinancialGroups: "financial-group/resetModule",
      setPageMounted: "invoicing/setPageMounted",
      setInvoicingTab: "invoicing/setInvoicingTab",
      resetContracts: "contract/resetModule",
      resetInvoicing: "invoicing/resetState",
      loadingPage: "invoicing/loadingPage",

      setInsuranceCarriers: "insurance-carrier/setInsuranceCarriers",
      setIsRHProtegido: "user-info/setIsRHProtegido",
      setAppOrigin: "user-info/setAppOrigin",
    }),
    validateTabPermission(tab) {
      return true;
      if (tab === "invoicing") {
        return this.hasPermission("sdi_invoicing_tab_invoices");
      }
      return this.hasPermission("sdi_invoicing_tab_reports");
    },
    getSelectedFileIds(selectedFiles) {
      this.resetSelectedFiles();
      selectedFiles.map((file) => {
        this.selectedFileIds.push(file.fileId);
      });
      console.log(this.selectedFileIds);
    },
    resetSelectedFiles() {
      this.selectedFileIds = [];
    },
    openNewTab() {
      const url = new URL(window.location.href);
      url.searchParams.set("maximize", "false");
      window.open(url.toString(), "_blank");
    },

    async fetchQueryParameters() {
      this.maximize = this.$route.query && this.$route.query.hasOwnProperty("maximize") ? this.stringToBoolean(this.$route.query.maximize) : false;

      if (!this.hasInvoicingQueryParameters()) return;

      const invoicingQueryKeys = ["competency", "financialGroupId", "contractId", "subContractId", "externalProtocol"];
      const invoicingQueryFilter = Object.fromEntries(invoicingQueryKeys.map((key) => [key, this.$route.query[key]]));

      const competency = moment(invoicingQueryFilter.competency, "YYYY-MM");
      const competenceMonth = parseInt(competency.format("MM"));
      const competenceYear = parseInt(competency.format("YYYY"));
      const financialGroupId = invoicingQueryFilter.financialGroupId && parseInt(invoicingQueryFilter.financialGroupId);
      const contractId = invoicingQueryFilter.contractId && parseInt(invoicingQueryFilter.contractId);
      const subContractId = invoicingQueryFilter.subContractId && parseInt(invoicingQueryFilter.subContractId);
      const externalProtocol = invoicingQueryFilter.externalProtocol || null;

      const rawParams = {
        competenceMonth,
        competenceYear,
        financialGroupId,
        contractId,
        subContractId,
        externalProtocol,
      };

      const invoicingParameter = Object.entries(rawParams)
        .filter(([_, value]) => value !== null && value !== undefined)
        .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});

      this.setInvoicingFilter(invoicingParameter);

      if (this.hasInvoicingQueryParameters()) {
        if (financialGroupId) {
          await this.getContractsByFinancialGroupIdVerifyRhProtegido(financialGroupId, this.isRHProtegido);
        }

        if (contractId) {
          await this.getSubContractsByContractId(contractId);
        }
      }
    },
  },

  computed: {
    ...mapGetters({
      showConfirmModal: "invoicing/showConfirmModal",
      showRequestModal: "invoicing/showRequestModal",
      fGroups: "financial-group/groups",
      invoicingTab: "invoicing/invoicingTab",
      appOrigin: "user-info/appOrigin",
      loadPage: "invoicing/loadPage",
    }),

    invoicingTabItems: {
      get() {
        return this.invoicingTab;
      },

      set(value) {
        this.setInvoicingTab(value);
      },
    },

    btnFooter() {
      return BTN_FOOTER;
    },

    showSubFilterComponentView() {
      return this.showSubFilterComponent;
    },
  },

  async created() {
    this.isHelpdesk = Boolean(this.$route.query.helpdeskId);
    const isRHProtegido = this.$route.query.isRHProtegido ? this.stringToBoolean(this.$route.query.isRHProtegido.toString()) : this.appOrigin && this.appOrigin !== "BACKOFFICE" && !this.isHelpdesk;

    this.setIsRHProtegido(isRHProtegido);
    this.setAppOrigin(isRHProtegido ? "PROTECTED_HR" : "BACKOFFICE");

    this.loadingPage(true);

    try {
      await Promise.all([this.getInsuranceCarriers(), this.getFinancialGroups()]);

      await this.fetchQueryParameters();

      setTimeout(async () => {
        await this.fetchInvoices();
      }, 500);
    } catch (error) {
      this.$refs.InvoicingSnackbar.open("error", "Ocorreu um erro ao carregar os dados da página");
    } finally {
      this.loadingPage(false);

      this.setPageMounted(true);
    }
  },

  mounted() {
    if (this.fGroups && this.fGroups.length === 1) {
      this.setInvoicingFilter({
        financialGroupId: this.fGroups[0].id,
      });
    }

    this.resizeObserver = new ResizeObserver(() => {
      this.invoicingScrollHeightObserver = document.body.scrollHeight;
    });
    this.resizeObserver.observe(document.body);
  },

  beforeDestroy() {
    this.resetInsuranceCarriers();
    this.resetFinancialGroups();
    this.resetContracts();
    this.resetInvoicing();

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
};
</script>
